import "./views.scss";

import { useEffect } from "react";

import PersonalizeLater from "../components/buttons/PersonalizeLater";
import PrimaryButton from "../components/buttons/PrimaryButton";
import DynamicFormField from "../components/forms/formFields/DynamicFormField";
import { useFormFlowContext } from "../components/forms/FormFlowContext";
import { triggerCommunityRegistrationView } from "../helpers/observability/analytics";
import appSettings from "../settings/appSettings";
import { getCurrentQuestion } from "../utils/formFlowUtils";

/**
 * SurveyQuestionPage component renders a survey question page with dynamic form fields.
 *
 * @param {Object} props - The component props.
 * @param {Object} props.formMethods - Methods for handling form state and actions.
 * @param {Function} props.handleClickPersonalizeLater - Function to handle the "Personalize Later" button click.
 *
 * @returns {JSX.Element|null} The rendered survey question page or null if there are no questions or none at the current index.
 */
const SurveyQuestionPage = ({ formMethods, handleClickPersonalizeLater }) => {
  const { getFormState } = formMethods;
  const formState = getFormState();

  const { pageForward, currentPage } = useFormFlowContext();
  const { surveyConfig, badges } = appSettings;
  const { headerText, subheaderText, surveyQuestions = [] } = surveyConfig;

  const { currentQuestion, isEnd } = getCurrentQuestion(
    badges.length,
    surveyQuestions,
    currentPage
  );

  useEffect(() => {
    if (currentQuestion?.analyticsAction && currentQuestion?.questionText) {
      triggerCommunityRegistrationView({
        event_action: currentQuestion.analyticsAction,
        event_label: currentQuestion.questionText
      });
    }
  }, [currentQuestion?.analyticsAction, currentQuestion?.questionText]);

  if (!currentQuestion) {
    return null;
  }

  const handleClickNext = () => {
    pageForward(isEnd);
  };

  return (
    <div className="views display-grid gap-tight">
      <div className="header">
        <h1 className="serif">
          <strong>{headerText}</strong>
        </h1>
      </div>
      {subheaderText && <p className="base intro">{subheaderText}</p>}
      <p className="base form_bold">{currentQuestion.questionText}</p>
      <DynamicFormField
        formMethods={formMethods}
        type={currentQuestion.type}
        validationType={currentQuestion.validationType}
        field={currentQuestion}
        formFields={formState?.fields}
        columns={currentQuestion.columns}
      />
      <footer className="footer">
        <PrimaryButton handleClick={handleClickNext}>Next</PrimaryButton>
        <PersonalizeLater handleClick={handleClickPersonalizeLater} />
      </footer>
    </div>
  );
};

export default SurveyQuestionPage;
